/* eslint-disable @typescript-eslint/naming-convention */
import axiosInstanceApiKong from 'config/apiServiceApiGateway'
import { Get } from 'config/apiServiceConfig'

export type GetAreaListParamsType = Partial<{
  page_index: number
  page_size: number
  search_name: string
  location_id: number
}>

export type GetAreaListRequestType = {
  'filter.location_id'?: number
  'filter.search_name'?: string
  'filter.storage_environment_id'?: number
  'pagination.page_index': number
  'pagination.page_size': number
}

export type GetAreaDetailResponseType = {
  id: number
  name: string
  location: {
    id: number
    name: string
  }
  product_categories: {
    category_id: number
    category_name: string
  }[]
  high_risk: boolean
  high_value: boolean
  is_halal: boolean
  storage_environment: {
    id: number
    name: string
  }
  alternative_area: {
    id: number
    name: string
  }[]
  max_sku_per_asset: number
}

export type GetAreaListResponseType = GetAreaDetailResponseType[]

export type PostAreaRequestType = {
  location_id: number
  name: string
  product_category_ids: number[]
}

export type PutAreaRequestType = {
  id: number
  data: {
    name: string
    product_category_ids: number[]
  }
}

export type PostPutAreaResponseType = {
  message: string
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type GetCategoriesResponseType = {
  category_id: number
  category_name: string
}[]

export type CreateUpdateAreaRequestType = {
  location_id: number
  name: string
  product_category_ids: number[]
  high_risk: boolean
  high_value: boolean
  is_halal: boolean
  storage_environment_id: number
  area_alternative_ids: number[]
}

export const getAreaDetailAPI = (id: number) =>
  axiosInstanceApiKong.Get<GetAreaDetailResponseType>({
    url: `/wms/internal/v1/areas/${id}`,
  })

export const getAreaDetail = (id: number) =>
  axiosInstanceApiKong.Get<GetAreaDetailResponseType>({
    url: `/wims/internal/v1/areas/${id}`,
  })

export const postAreaAPI = (payload: PostAreaRequestType) =>
  axiosInstanceApiKong.Post<PostPutAreaResponseType>({
    url: '/wms/internal/v1/areas',
    data: payload,
  })

export const putAreaAPI = ({ id, data }: PutAreaRequestType) =>
  axiosInstanceApiKong.Put<PostPutAreaResponseType>({
    url: `/wms/internal/v1/areas/${id}`,
    data,
  })

export const getCategoriesAPI = () =>
  Get<GetCategoriesResponseType>({
    url: `/api/categories/child`,
  })

export const getAreaList = (params: GetAreaListRequestType) =>
  axiosInstanceApiKong.Get<GetAreaListResponseType>({
    url: '/wims/internal/v1/areas',
    params,
  })

export const postArea = (data: CreateUpdateAreaRequestType) =>
  axiosInstanceApiKong.Post<PostPutAreaResponseType, true>({
    url: '/wims/internal/v1/areas',
    data,
  })

export const putArea = (id: number, data: CreateUpdateAreaRequestType) =>
  axiosInstanceApiKong.Put<PostPutAreaResponseType, true>({
    url: `/wims/internal/v1/areas/${id}`,
    data,
  })
